import { sessionStorage, localStorage } from 'pangu-core'
import { useRoute } from 'vue-router/composables'
export function useSetStorageComponent(parametersStorageSuffix = '') {
  const route = useRoute()
  const name = route.name
  const setParametersBySessionStorage = (val) =>
    sessionStorage.set(`${name}_plus_parameters_${parametersStorageSuffix}`, val)

  const setComponentBySessionStorage = (val) =>
    sessionStorage.set(`${name}_plus_component_${parametersStorageSuffix}`, val)

  const getParametersBySessionStorage = () =>
    sessionStorage.get(`${name}_plus_parameters_${parametersStorageSuffix}`)

  const getComponentBySessionStorage = () =>
    sessionStorage.get(`${name}_plus_component_${parametersStorageSuffix}`)

  const removeParametersBySessionStorage = () =>
    sessionStorage.remove(`${name}_plus_parameters_${parametersStorageSuffix}`)

  const removeComponentBySessionStorage = () =>
    sessionStorage.remove(`${name}_plus_component_${parametersStorageSuffix}`)

  //设置pageSize
  const getPageSizeLocalStorage = () =>
    localStorage.get(`${name}_plus_page_query_pagesize_${parametersStorageSuffix}`)

  const setPageSizeLocalStorage = (val) =>
    localStorage.set(`${name}_plus_page_query_pagesize_${parametersStorageSuffix}`, val)

  const setParametersByLocalStorage = (val) =>
    localStorage.set(`${name}_plus_parameters_${parametersStorageSuffix}`, val)

  const getParametersByLocalStorage = () =>
    localStorage.get(`${name}_plus_parameters_${parametersStorageSuffix}`)

  const getComponentByLocalStorage = () =>
    localStorage.get(`${name}_plus_component_${parametersStorageSuffix}`)

  const setComponentByLocalStorage = (val) =>
    localStorage.set(`${name}_plus_component_${parametersStorageSuffix}`, val)

  return {
    setComponentBySessionStorage,
    setParametersBySessionStorage,
    getComponentBySessionStorage,
    getParametersBySessionStorage,
    removeParametersBySessionStorage,
    removeComponentBySessionStorage,
    getPageSizeLocalStorage,
    setPageSizeLocalStorage,

    getParametersByLocalStorage,
    setParametersByLocalStorage,
    getComponentByLocalStorage,
    setComponentByLocalStorage,
  }
}
